import { connect } from "react-redux";
import * as actions from "./actions";
import { BUSINESS_PATH } from "../../routing/paths";
import CategoriesStep from "../../components/CategoriesStep";
import { WizardProps } from "../Wizard";
import { invocate, changePath } from "../Wizard/actions";
import { CategoriesStepReducer } from "./reducer";
import { notBlank } from "../../shared/validations";

type ReducerProps = {
  categoriesStep: CategoriesStepReducer;
  wizard: WizardProps;
  previous: string;
  validation: Function;
};

const mapStateToProps = ({ categoriesStep, wizard }: ReducerProps) => ({
  previous: BUSINESS_PATH,
  loading: categoriesStep.loading,
  subCategories: categoriesStep.subCategories,
  invocations: wizard.invocations,
  validation: notBlank,
});

export default connect(mapStateToProps, { invocate, changePath, ...actions })(CategoriesStep);
